// @ts-expect-error build-time virtual module
import { bender } from 'legacy-hubspot-bender-context';
import { gate } from 'hub-http/gates';
// --- Hardcoded fallback ---
// TODO: remove once dynamic resolution is setup across the static-app-content-worker
const FALLBACK_REMOTES = [{
  remote: 'quartz-test-granite-remote-a',
  gate: 'Granite:TestRemoteA',
  routes: ['/remote-a/:portalId']
}, {
  remote: 'quartz-test-granite-remote-b',
  gate: 'Granite:TestRemoteB',
  routes: ['/remote-b/:portalId']
}, {
  remote: 'quartz-test-granite-remote-c',
  gate: 'Granite:TestRemoteC',
  routes: ['/remote-c/:portalId']
}, {
  remote: 'quartz-app-auth-test-ui',
  gate: 'Granite:QuartzAppAuthTestApp',
  routes: ['/quartz-app-auth-test-ui/:portalId', '/quartz-app-auth-test-ui-alt/:portalId']
}, {
  remote: 'crm-index-ui',
  gate: 'FrontendFramework:Granite:CRMApps',
  routes: [
  /**
   *  These are intentionally omitted due to potential for traffic stealing.
   *
   * Examples of this would be segments-ui, prospecting-ui
   *
   *
   * '/contacts',
   * '/contacts/:portalId',
   */
  '/contacts/:portalId/objects/:objectTypeId/views/all/:viewType',
  // viewType is list, board, report ,etc.
  '/contacts/:portalId/objects/:objectTypeId/views/:viewId/:viewType', '/contacts/:portalId/objects/:objectTypeId/restore'

  // Leave these disabled for now, lets just use a few specific routes
  // '/contacts/:portalId/objects',
  // '/contacts/:portalId/search',
  // '/contacts/:portalId/companies',
  // '/prospecting/:portalId/objects',
  // { path: '/contacts/:portalId/contacts', priority: 1 },
  // { path: '/contacts/:portalId/deals', priority: 1 },
  // { path: '/contacts/:portalId/tickets', priority: 1 },
  ]
}, {
  remote: 'crm-records-ui',
  gate: 'FrontendFramework:Granite:CRMApps',
  routes: ['/contacts/:portalId/record/:objectTypeId/:objectId'
  // leave these disabled for now and just use a few specific routes
  // '/contacts/:portalId/company',
  // '/contacts/:portalId/contact',
  // '/contacts/:portalId/deal',
  // '/contacts/:portalId/ticket',
  // '/contacts/:portalId/record/:recordId',
  // '/contacts/:portalId/quote',
  // '/contacts/:portalId/companies/:companyId',
  // { path: '/contacts/:portalId/contacts/:contactId', priority: 1 },
  // { path: '/contacts/:portalId/deals/:dealId', priority: 1 },
  // { path: '/contacts/:portalId/tickets/:ticketId', priority: 1 },
  ]
}];
const BLOCKLISTED_ROUTES = ['/contacts/:portalId/record/:objectTypeId/:objectId/history', '/contacts/:portalId/record/:objectTypeId/:objectId/properties'];
export function getBlocklistedRoutes() {
  return BLOCKLISTED_ROUTES;
}
let cachedGraniteRemotes = null;
const currentPackageName = bender.bundlingPackage;

/**
 * Resolves the granite route map from the environment.
 *
 * Tier 1 (production): static-app-content-worker injects window.__GRANITE_ROUTE_MAP__
 * Tier 2 (local dev):  bend serve endpoint (not yet implemented)
 * Fallback:            hardcoded list (temporary, removed after dynamic resolution is verified)
 */
function resolveGraniteRemotes() {
  if (cachedGraniteRemotes) {
    return cachedGraniteRemotes;
  }

  // Tier 1: static-app-content-worker injected route map (production, synchronous)
  if (window.__GRANITE_ROUTE_MAP__) {
    cachedGraniteRemotes = Object.entries(window.__GRANITE_ROUTE_MAP__).map(([remote, config]) => ({
      remote,
      gate: config.gate,
      routes: config.routes,
      redirects: config.redirects
    }));
    return cachedGraniteRemotes;
  }

  // Fallback: hardcoded list
  cachedGraniteRemotes = FALLBACK_REMOTES;
  return cachedGraniteRemotes;
}
export function isGraniteEnabledForCurrentApp(gates) {
  const graniteRemotes = resolveGraniteRemotes();
  const currentRemote = graniteRemotes.find(r => r.remote === currentPackageName);
  if (!currentRemote) {
    return false;
  }
  if (!currentRemote.gate) {
    return true;
  }
  // eslint-disable-next-line hubspot-dev/no-bare-gate-strings
  const enabled = gates.has(gate(currentRemote.gate));
  return enabled;
}
function normalizeRouteEntry(entry) {
  var _entry$priority;
  if (typeof entry === 'string') {
    return {
      path: entry,
      priority: 0
    };
  }
  return {
    path: entry.path,
    priority: (_entry$priority = entry.priority) !== null && _entry$priority !== void 0 ? _entry$priority : 0
  };
}
export function getUngatedRemoteRoutes(gates) {
  const graniteRemotes = resolveGraniteRemotes();
  const ungatedRemotes = graniteRemotes.filter(
  // eslint-disable-next-line hubspot-dev/no-bare-gate-strings
  r => !r.gate || gates.has(gate(r.gate)));
  const seen = new Set();
  const remoteModules = [];
  const localRouteOverrides = {};
  for (const ungatedRemote of ungatedRemotes) {
    const isLocal = ungatedRemote.remote === currentPackageName;
    if (!isLocal && !seen.has(ungatedRemote.remote)) {
      seen.add(ungatedRemote.remote);
      remoteModules.push(ungatedRemote.remote);
    }
    for (const entry of ungatedRemote.routes) {
      const {
        path: routeTemplate
      } = normalizeRouteEntry(entry);
      if (isLocal) {
        localRouteOverrides[routeTemplate] = {
          path: routeTemplate,
          remoteModule: undefined // navigating to the local app shouldn't use the remote module
        };
      } else {
        localRouteOverrides[routeTemplate] = {
          path: routeTemplate,
          remoteModule: ungatedRemote.remote
        };
      }
    }
  }
  return {
    remoteModules,
    localRouteOverrides
  };
}